import {Button, Grid, makeStyles} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {moveNextPage, updateCreatorOnboarding} from "../../../../../store/actions/creator/creatorOnBoarding";
import {useHistory, useLocation} from "react-router";
import UtilService from "../../../../../helper/service";

const useStyles = makeStyles(() => ({
  title: {
    marginTop: 20,
    textAlign: 'center',
    fontSize: (props: any) => props.height < 770 ? 38 : 42,
    color: '#212D40',
    fontFamily: 'Spartan-bold',
    '@media (max-width: 600px)': {
      fontSize: '23px!important',
    },
  },
  subTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 15,
    marginBottom: 15,
    '& p': {
      maxWidth: 800,
      margin: 0,
      textAlign: 'center',
      fontSize: 24,
      color: '#212D40',
      fontFamily: 'roboto-light',
      lineHeight: (props: any) => props.height < 770 ? 1.2 : 1.5,
      '@media (max-width: 600px)': {
        fontSize: '15px!important',
      },
    },
  },
  img: {
    height: 140,
    width: 'auto',
    borderRadius: 10,
  },
  addNewBtn: {
    fontFamily: 'roboto-regular',
    fontSize: 20,
    marginLeft: 5,
    marginRight: 5,
    '@media (max-width: 600px)': {
      fontSize: 11,
    },
  },
  btn: {
    marginTop: 20,
    marginBottom: 20,
    borderRadius: 6,
    padding: '10px 80px 10px 80px',
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 14,
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
    '@media (max-width: 600px)': {
      padding: '3px 12px',
    },
  },
  figureWrapper: {
    position: 'relative',
    marginTop: 30,
    marginBottom: 30
  },
  imgBig: {
    margin: '0 auto',
    height: (props: any) => props.height < 770 ? 300 : 380,
    width: 'auto',
    '@media (max-width: 425px)': {
      width: '300px!important',
      height: '220px!important'
    },
  },
  imgSmall: {
    position: 'absolute',
    width: '200px',
    height: '120px',
    top: (props: any) => props.height < 770 ? 65 : 103,
    left: (props: any) => props.height < 770 ? 50 : 90,
    overflow: 'hidden',
    '@media (max-width: 425px)': {
      top: '45px!important',
      left: '27px!important',
      width: '160px!important',
      height: '84px!important'
    },
  },
  imgFull: {
    display: 'block',
    height: '100%',
    width: 'auto',
  },
}));

const Module2Slide3 = () => {

  const size = UtilService.useWindowSize();
  const classes = useStyles(size);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { userPreferences } = useSelector((state: any) => state.creatorOnBoarding);
  const { pickvideoinfo, activepage } = userPreferences;
  const [asyncFileName, setAsyncFileName] = useState('');
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";

  useEffect(() => {
    window.addEventListener('keydown', handleUserKeyPress);
    return () => {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  });

  useEffect(() => {
    UtilService.addHashTag(history, location.pathname, 'm2s3');
  }, []);

  useEffect(() => {
    const information = JSON.parse(pickvideoinfo.value);
    setAsyncFileName(information['asyncFileName'])
  }, [pickvideoinfo]);

  const handleUserKeyPress = (event: any) => {
    if (event.keyCode === 13) {
      goNext();
    }
  };

  const goNext = () => {
    if (Number(activepage.value) < 12) {
      const reqActivePage = {
        user_id: loginUserData.user_id,
        preference_id: userPreferences.activepage.id,
        preference_name: 'ACTIVEPAGE',
        preference_information: '12',
      };
      dispatch(updateCreatorOnboarding(apolloClient.client, reqActivePage));

      const reqActiveStep = {
        user_id: loginUserData.user_id,
        preference_id: userPreferences.activestep.id,
        preference_name: 'ACTIVESTEP',
        preference_information: '2',
      };
      dispatch(updateCreatorOnboarding(apolloClient.client, reqActiveStep));
    }

    dispatch(moveNextPage(12))
  };

  return (
    <div>
      <Grid container justifyContent='center'>
        <Grid item lg={12} md={12} sm={12} className={classes.title}>
          Congrats! You’ve completed Module 2!
        </Grid>
        <div className={classes.subTitle}>
          <p>
            While we wait for our participants to watch your video and be measured,
            let’s quickly complete Module 3, which only takes a couple of minutes.
          </p>
        </div>
        <Grid item lg={12} md={12} sm={12} justifyContent='center' container>
          <div className={classes.figureWrapper}>
            <figure className={classes.imgBig}>
              <img src="/assets/icons/onboarding/module2-finish.svg" className={classes.imgFull} />
            </figure>
            <figure className={classes.imgSmall}>
              <img src={asyncFileName} className={classes.imgFull} />
            </figure>
          </div>
        </Grid>
        <Grid item lg={12} md={12} sm={12} justifyContent='center' container>
          <Button
            color='primary'
            className={classes.btn}
            onClick={goNext}
          >
            <span className={classes.addNewBtn}>Start Module 3</span>
          </Button>
        </Grid>
      </Grid>
    </div>
  )

};

export default Module2Slide3;